import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessFeatureStockTakeSettings
export interface IUserAccessFeatureStockTakeSettings {
  overrides: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_STOCK_TAKE_SETTINGS
export const _DEFAULT_USER_ACCESS_STOCK_TAKE_SETTINGS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_FEATURE_STOCK_TAKE_SETTINGS
export const _DEFAULT_USER_ACCESS_FEATURE_STOCK_TAKE_SETTINGS: Readonly<IUserAccessFeatureStockTakeSettings & Object> = {
  overrides: _DEFAULT_USER_ACCESS_STOCK_TAKE_SETTINGS,
};
//#endregion
